import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { QueryClient, QueryClientProvider } from 'react-query';
import { Toaster } from 'react-hot-toast';
import App from './App';
import { AuthProvider } from '@shared/authContext';
import './index.css';

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: 1,
      refetchOnWindowFocus: false,
    },
  },
});

// Get base path for React Router
// In production, detect from URL pathname (apps are at /admin and /tech)
// In development, use Vite's BASE_URL or undefined (runs at root)
const getBasename = () => {
  // Check if we're in production (not localhost/dev server)
  const isProduction = window.location.hostname !== 'localhost' && !window.location.hostname.startsWith('127.0.0.1');
  
  if (isProduction) {
    // In production, detect from current pathname
    const pathname = window.location.pathname;
    if (pathname.startsWith('/admin')) {
      return '/admin';
    }
    // Fallback to Vite's BASE_URL if available
    const baseUrl = import.meta?.env?.BASE_URL || '';
    if (baseUrl) {
      return baseUrl.replace(/\/$/, '');
    }
  } else {
    // In development, use Vite's BASE_URL or undefined (runs at root)
    const baseUrl = import.meta?.env?.BASE_URL || '';
    const basename = baseUrl.replace(/\/$/, '');
    return basename || undefined;
  }
  
  return undefined;
};

ReactDOM.createRoot(document.getElementById('root')).render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <BrowserRouter basename={getBasename()}>
        <AuthProvider>
          <App />
          <Toaster
            position="top-right"
            toastOptions={{
              duration: 4000,
              style: {
                background: '#363636',
                color: '#fff',
              },
            }}
          />
        </AuthProvider>
      </BrowserRouter>
    </QueryClientProvider>
  </React.StrictMode>
);
